import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getLiteral } from 'utils/getLiteral';

const useBillboardDetail = () => {
    const { adminBillboard, editBillboard, deleteBillboard, isReader } = useSelector((state) => ({
        adminBillboard: state.config.permission.adminBillboard,
        editBillboard: state.config.permission.editBillboard,
        deleteBillboard: state.config.permission.deleteBillboard,
        isReader: state.billboard.menu.isReader,
    }));

    const getOptions = useCallback(
        (data) => {
            if (!data || !Object.keys(data)?.length) return [];
            const options = [];
            if (adminBillboard && editBillboard && !isReader) options.push('edit');
            if (deleteBillboard && !isReader) options.push('delete');
            return options;
        },
        [adminBillboard, editBillboard, deleteBillboard, isReader],
    );

    const modalTitle = useMemo(() => getLiteral('action_delete'), []);
    const modalContent = useMemo(() => getLiteral('confirm_delete'), []);

    return {
        getOptions,
        modalTitle,
        modalContent,
    };
};

export default useBillboardDetail;
